/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".labels-wrapper[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font-family:PoppinsRegular;font-size:1.5rem;font-weight:400;font-style:normal;font-stretch:normal;line-height:1.93;letter-spacing:normal;color:#007efe}"];
export { styles as styles };
//# sourceMappingURL=level-test-results-section.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/test-results/level-test-results-section/level-test-results-section.component.scss.shim.ngstyle.js
// module id = 1708
// module chunks = 27 28 29